export const AddressTypes = {
    isDefault: "Domyślny",
    isPickup: "Dostawa",
    isCentral: "Siedziba",
    isBdoLinked: "BDO",
    isActive: "Aktywny",
    isHidden: "Nieaktywny"
  };
  

  export const AddressTypesBadges = {
    isDefault: "info",
    isPickup: "fiolet",
    isCentral: "indigo",
    isBdoLinked: "primary",
    isActive: "success",
    isHidden: "secondary"
  };